export default "__VITE_ASSET__C8WPp6Tr__"